import { render, staticRenderFns } from "./FaceList.vue?vue&type=template&id=233b14a2&scoped=true"
import script from "./FaceList.vue?vue&type=script&lang=ts"
export * from "./FaceList.vue?vue&type=script&lang=ts"
import style0 from "./FaceList.vue?vue&type=style&index=0&id=233b14a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b14a2",
  null
  
)

export default component.exports